import React, { useState, useEffect } from 'react';
import {
  Select,
  Card,
  Input,
  Button,
  message,
  Typography,
  Spin,
  DatePicker,
  Row,
  Col,
  Divider,
} from 'antd';
import ManagerService from '../../services/ManagerService';
import moment from 'moment';

const { Option } = Select;
const { Title, Text } = Typography;

const ThanhToanCongNoComponent = () => {
  const [data, setData] = useState([]);
  const [selectedMaHd, setSelectedMaHd] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [soTienThanhToan, setSoTienThanhToan] = useState('');
  const [ngayThanhToan, setNgayThanhToan] = useState(moment());
  const [loading, setLoading] = useState(false);

  // Lấy danh sách đơn công nợ
  useEffect(() => {
    const fetchCongNoData = async () => {
      setLoading(true);
      try {
        const response = await ManagerService.getDanhSachCongNo();
        setData(response.data);
      } catch (error) {
        message.error('Lỗi khi lấy dữ liệu công nợ');
      } finally {
        setLoading(false);
      }
    };
    fetchCongNoData();
  }, []);

  const handleSelectChange = (ma_hd) => {
    setSelectedMaHd(ma_hd);
    const record = data.find((item) => item.ma_hd === ma_hd);
    setSelectedRecord(record);
    setSoTienThanhToan('');
    setNgayThanhToan(moment());
  };

  const handleLuuThanhToan = async () => {
    const soTien = parseFloat(soTienThanhToan);

    if (!selectedRecord) {
      message.warning('Vui lòng chọn mã hợp đồng.');
      return;
    }

    if (isNaN(soTien) || soTien <= 0) {
      message.error('Vui lòng nhập số tiền hợp lệ.');
      return;
    }

    if (soTien > selectedRecord.cong_no_ton) {
      message.error('Số tiền thanh toán không được vượt quá công nợ còn lại.');
      return;
    }

    try {
      await ManagerService.thanhToanCongNo(
        selectedRecord.ma_hd,
        soTien,
        ngayThanhToan.format('YYYY-MM-DD') // truyền ngày thanh toán
      );

      message.success('Thanh toán thành công!');
      const newCongNoTon = selectedRecord.cong_no_ton - soTien;

      const updatedRecord = { ...selectedRecord, cong_no_ton: newCongNoTon };
      setSelectedRecord(updatedRecord);

      const updatedData = data.map((item) =>
        item.ma_hd === selectedRecord.ma_hd ? updatedRecord : item
      );
      setData(updatedData);
      setSoTienThanhToan('');
    } catch (error) {
      message.error('Lỗi khi thanh toán: ' + error.message);
    }
  };

  return (
    <div style={{ padding: '24px', maxWidth: 800, margin: '0 auto' }}>
      <Title level={3}>Thanh Toán Công Nợ</Title>

      <div style={{ marginBottom: 24 }}>
        <Text strong>Chọn mã hợp đồng:</Text>
        <Select
          showSearch
          placeholder="Chọn mã hợp đồng cần thanh toán"
          style={{ width: '100%', marginTop: 8 }}
          onChange={handleSelectChange}
          value={selectedMaHd}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {data.map((item) => (
            <Option key={item.ma_hd} value={item.ma_hd}>
              {item.ma_hd} - {item.ma_khach_hang}
            </Option>
          ))}
        </Select>
      </div>

      {loading ? (
        <Spin />
      ) : (
        selectedRecord && (
          <>
            <Card title="Thông tin chi tiết công nợ" style={{ marginBottom: 24 }}>
              <Row gutter={[16, 8]}>
                <Col span={12}>
                  <Text><strong>Đơn vị:</strong> {selectedRecord.don_vi}</Text><br />
                  <Text><strong>Dịch vụ:</strong> {selectedRecord.dich_vu}</Text><br />
                  <Text><strong>Tuyến Sale:</strong> {selectedRecord.tuyen_sale}</Text><br />
                </Col>
                <Col span={12}>
                  <Text><strong>Kỳ phát sinh:</strong> {moment(selectedRecord.ky_ps).format('DD/MM/YYYY')}</Text><br />
                  <Text><strong>Mã nhân viên:</strong> {selectedRecord.ma_nv}</Text><br />
                  <Text><strong>Tên đơn vị:</strong> {selectedRecord.ten_don_vi}</Text><br />
                </Col>
              </Row>
              <Divider />
              <Text><strong>Tổng công nợ:</strong> {selectedRecord.tong_cong_no.toLocaleString()} VND</Text><br />
              <Text><strong>Công nợ còn lại:</strong> <span style={{ color: 'red' }}>{selectedRecord.cong_no_ton.toLocaleString()} VND</span></Text>
            </Card>

            <Card title="Thanh toán">
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Input
                    type="number"
                    placeholder="Nhập số tiền thanh toán"
                    value={soTienThanhToan}
                    onChange={(e) => setSoTienThanhToan(e.target.value)}
                  />
                </Col>
                <Col span={12}>
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD/MM/YYYY"
                  value={ngayThanhToan}
                  onChange={(date) => {
                    if (date && date.isValid()) {
                      setNgayThanhToan(date);
                    }
                  }}
                  // Optional: Giới hạn chọn tới hôm nay
                  disabledDate={(current) => current && current > moment().endOf('day')}
                />
                </Col>
                <Col span={24}>
                  <Button type="primary" onClick={handleLuuThanhToan}>
                    Xác nhận thanh toán
                  </Button>
                </Col>
              </Row>
            </Card>
          </>
        )
      )}
    </div>
  );
};

export default ThanhToanCongNoComponent;
